import { useTranslation } from 'react-i18next';
import { DialogTitle } from '@shared/typography/title';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { UserFormView } from '@app/feature/user/generic-user/user-form/user-form.view';
import { Snackbar } from '@shared/snackbar/snackbar';
import { useUpdateDeveloperMutation } from '@service/developer.service';
import { BackOfficeUserModel } from '@delmonicos/shared-sdk/libs/emsp/src/libs/back-office/src/models/users/back-office-user.model';
import { UpdateDeveloperModel } from '@delmonicos/shared-sdk/libs/emsp/src/libs/back-office/src/models/users/update-user.model';

interface DeveloperUpdateProps {
  developer: BackOfficeUserModel;
  onCancel: () => void;
  onSuccess: () => void;
  onError: () => void;
}

export function DeveloperUpdate({
  developer,
  onCancel,
  onSuccess,
  onError,
}: DeveloperUpdateProps): React.JSX.Element {
  const { t } = useTranslation();

  const [handleUpdateDeveloper, { isLoading, isError, error }] =
    useUpdateDeveloperMutation();

  const handleSubmit = (updatedDeveloper: UpdateDeveloperModel) => {
    if (!developer.id) {
      onError();
      return;
    }

    handleUpdateDeveloper({
      id: developer.id,
      ...updatedDeveloper,
    })
      .unwrap()
      .then(onSuccess)
      .catch(onError);
  };

  return (
    <>
      <DialogTitle icon={<EditOutlinedIcon />}>
        {t('user.developer.update.title')}
      </DialogTitle>

      <UserFormView
        defaultValues={developer}
        formType="update"
        onSubmit={handleSubmit}
        pending={isLoading}
        onCancel={onCancel}
      />

      {isError && (
        <Snackbar
          variant="error"
          message={t('error.patch-user-mutation', { error })}
        />
      )}
    </>
  );
}
